import type { AdvancedFilters, Session } from './types'

/**
 * Aplica filtros avançados com lógica AND.
 * Cada filtro ativo restringe o resultado; filtros null são ignorados.
 */
export const applyAdvancedFilters = (
  sessions: Session[],
  filters: AdvancedFilters
): Session[] => {
  const { place, speaker, kind } = filters

  // Short-circuit: sem filtros ativos
  if (!place && !speaker && !kind) return sessions

  return sessions.filter(session => {
    if (place && session.place?.name !== place) return false
    if (kind && session.kind !== kind) return false
    if (speaker) {
      const hasSpeaker = session.speakers?.some(s => s?.id === speaker)
      if (!hasSpeaker) return false
    }
    return true
  })
}
